import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { Paper } from '@mui/material'
import { useStyles } from './styles'
import SystemNotifications from '../SystemNotifications/SystemNotifications'
import ProductAnnouncements from '../ProductAnnouncements/ProductAnnouncements'
import { selectGlobalNotificationTab } from '../../../selectors/globalNotification'

const GlobalNotificationTabView = () => {
    const selectedGlobalNotificationTab = useSelector(selectGlobalNotificationTab)
    const { classes } = useStyles()

    const view = useMemo(() => {
        switch (selectedGlobalNotificationTab) {
            case 'system':
                return <SystemNotifications />
            case 'updates':
                return <ProductAnnouncements />
            default:
                return null
        }
    }, [selectedGlobalNotificationTab])

    const jsxTree = useMemo(() => <Paper className={classes.container}>{view}</Paper>, [view])

    return jsxTree
}

export default React.memo(GlobalNotificationTabView)
